import { XMLExporter } from 'substance'

export default
class TextureJATSExporter extends XMLExporter {

}
